angular.module('memberPortal').controller('BookingsCtrl', ["$scope", "$state", "$stateParams", "$http", "$filter", "DataService", "Bookings", function($scope, $state, $stateParams, $http, $filter, DataService, Bookings) {
  var domain, loadBookings;
  $scope.data = DataService;
  domain = $scope.data.domain;
  $scope.hash = $stateParams.m;
  $scope.isLoading = true;
  $scope.bookings = [];
  $scope.page = 1;
  $scope.displayTime = function(time, booking) {
    if (booking.event_tz_type === 'browser') {
      return moment.utc(time, 'YYYY/MM/DD HH:mm').local().format('ddd, D MMM – h:mma');
    } else {
      return moment(time, 'YYYY/MM/DD HH:mm').format('ddd, D MMM – h:mma');
    }
  };
  $scope.displayStatus = function(booking) {
    var order;
    switch (false) {
      case !booking.member_portal_booking_status:
        return booking.member_portal_booking_status;
      case !booking.on_waitlist:
        order = $filter('ordinalize')(booking.waitlist_position);
        return `(${order} on waitlist)`;
    }
  };
  $scope.loadMore = function() {
    if ($scope.isLoading || $scope.bookings.length >= $scope.total) {
      return;
    }
    $scope.page = $scope.page + 1;
    return loadBookings();
  };
  $scope.bookingDetails = function(booking) {
    return [booking.location_name, booking.instructor_names].join(', ');
  };
  loadBookings = function() {
    return Bookings.getList({
      count: 10,
      page: $scope.page
    }).then(function(bookings) {
      $scope.total = bookings.meta.total;
      $scope.isLoading = false;
      return $scope.bookings = $scope.page > 1 ? $scope.bookings = _.sortBy([].concat($scope.bookings, bookings.plain()), 'start_at') : bookings.plain();
    });
  };
  return loadBookings();
}]);
